@if (show()) {
    <div class="loader" [ngClass]="{ center: position() === 'center', right: position() === 'right' }">
        <!-- eslint-disable-next-line @angular-eslint/template/prefer-ngsrc -->
        <img alt="{{ 'LOADING' }}" src="../../../assets/images/gifs/spinner.gif" />
    </div>
}
